import React from 'react';
import { Typography } from 'fronton-react';

type TParamProps = {
  label: string;
  value: string;
};

export const ParamComponent: React.FC<TParamProps> = ({ label, value }) => (
  <div>
    <Typography variant="m" size="body_accent" color="text-primary">
      {label}:&nbsp;
    </Typography>
    <Typography variant="m" size="body_short" color="text-secondary">
      {value}
    </Typography>
  </div>
);
